import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import { Grid, Button, Box, Paper } from '@mui/material';
import Divider from '@mui/material/Divider';
import { DialogTitleWithClose } from 'ui';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { EventsDocumentsUpload } from './EventsDocumentsUpload';

const useStyles = makeStyles({
  paper: {
    minWidth: 600,
  },
});

type EventsDocumentsModalProps = {
  documents: any[];
  onChange: (value: any[]) => void;
  open: boolean;
  onClose: () => void;
};

export const EventsDocumentsModal: FC<EventsDocumentsModalProps> = ({
  onChange,
  open,
  onClose,
  documents,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const handleSubmit = async () => {
    onClose();
  };

  const addFile = (file: File) => {
    if (documents.map(item => item.name).includes(file.name)) {
      return;
    }

    onChange([file, ...documents]);
  };

  const deleteFile = (file: File) => () =>
    onChange(documents.filter(item => item.name !== file.name));

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" classes={{ paper: classes.paper }}>
      {/* @ts-ignore */}
      <DialogTitleWithClose onClose={onClose}>{t('Documents upload')}</DialogTitleWithClose>
      <DialogContent>
        <Divider />
        <Box my={2}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid>
              <Typography>{`${t('File format')}: .pdf`}</Typography>
              <Typography>{`${t('Max size')}: 5 MB`}</Typography>
            </Grid>
            <Grid>
              <EventsDocumentsUpload onUpload={addFile} />
            </Grid>
          </Grid>
        </Box>
        <Divider />
        {documents.length === 0 ? (
          <Box m={8}>
            <Typography align="center">{t('No files currently uploaded')}</Typography>
          </Box>
        ) : (
          <Box pt={3}>
            {documents.map(item => (
              <Box key={item.name} mb={3}>
                <Paper>
                  <Box p={2}>
                    <Grid container justifyContent="space-between" alignItems="center">
                      <Typography align="center">{item.name}</Typography>
                      <IconButton onClick={deleteFile(item)} size="large">
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Box>
                </Paper>
              </Box>
            ))}
          </Box>
        )}
        <Box mb={2}>
          <Grid container justifyContent="flex-end">
            <Button color="primary" variant="contained" type="submit" onClick={handleSubmit}>
              {t('Save')}
            </Button>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
